import React from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import StudentMarks from "./StudentMarks";

interface RouteParams {
    testId: string;
    batchId: string;
}

const TestDataEntryPage = () => {
    const { testId, batchId } = useParams<RouteParams>();
    const history = useHistory();
    const location = useLocation();

    // Check if routed from testAnalysis by looking at query param
    const searchParams = new URLSearchParams(location.search);
    const isFromTestAnalysis = searchParams.get('source') === 'testAnalysis';

    const handleClose = () => {
        history.goBack();
    };

    return (
        <StudentMarks
            testId={Number(testId)}
            batchId={Number(batchId)}
            onClose={handleClose}
            isViewOnlyMode={isFromTestAnalysis}
        />
    );
};

export default TestDataEntryPage; 